import { create } from "zustand";
import type { Party } from "../types.js";

interface PartyStore {
	party: Party | null;
	updateParty: (newParty: Party) => void;
}

const usePartyStore = create<PartyStore>((set) => ({
	party: null,
	updateParty: (newParty) => {
		set(() => ({
			party: JSON.parse(JSON.stringify(newParty)) as Party,
		}));
	},
}));

export default usePartyStore;
